<template>
  <div class="contact-box">
    <div class="item" @mouseenter="qqShow = true" @mouseleave="qqShow = false">
      <img src="@/assets/pc/images/reference/1.jpg" alt="" />
      <transition name="fade">
        <div class="qq left-modal" v-if="qqShow">
          <a
            class="qq-item"
            target="_blank"
            href="http://wpa.qq.com/msgrd?v=3&uin=695396498&site=qq&menu=yes"
            >郑先生 <span>QQ:695396498</span></a
          >
        </div>
      </transition>
    </div>
    <div
      class="item"
      @mouseenter="phoneShow = true"
      @mouseleave="phoneShow = false"
    >
      <img src="@/assets/pc/images/reference/2.jpg" alt="" />
      <transition name="fade">
        <div class="left-modal main-phone" v-if="phoneShow">
          <div class="phone">
            <div>采购热线</div>
            <div class="red-font">132-3405-7463</div>
          </div>
        </div>
      </transition>
    </div>
    <div class="item" @click="maskShow = true">
      <img src="@/assets/pc/images/reference/3.jpg" alt="" />
    </div>
    <div
      class="item"
      @mouseenter="wechatShow = true"
      @mouseleave="wechatShow = false"
    >
      <img src="@/assets/pc/images/reference/4.jpg" alt="" />
      <transition name="fade">
        <div class="left-modal wechat" v-if="wechatShow">
          <div class="img">
            <img src="@/assets/pc/images/reference/serve.png" alt="" />
          </div>
          <p>扫码添加微信</p>
        </div>
      </transition>
    </div>
    <div class="item">
      <router-link to="/referencePreparation">
        <img src="@/assets/pc/images/reference/5.jpg" alt=""
      /></router-link>
    </div>

    <ReferenceMask :maskShow="maskShow" @close="close"></ReferenceMask>
  </div>
</template>

<script>
import ReferenceMask from "@/components/pc/reference/ReferenceMask";
export default {
  name: "ReferenceContact",
  components: {
    ReferenceMask
  },
  data() {
    return {
      qqShow: false,
      phoneShow: false,
      wechatShow: false,
      maskShow: false
    };
  },
  methods: {
    close() {
      this.maskShow = false;
    }
  }
};
</script>

<style lang="stylus" scoped>
.contact-box
  position fixed
  top 92px
  right 10px
  z-index 10
  .item
    width 76px
    height 66px
    margin-bottom 12px
    cursor pointer
    position relative
    padding-left 10px
    img
      width 100%
      height 100%
    .left-modal
      position absolute
      right 76px
      top 0
      background #fff
      font-size 14px
      padding 10px
      border-radius 3px
      border 1px solid #ddd
      &::before
        content ''
        position absolute
        top 10px
        right 0
        border-top 10px solid transparent
        border-left 10px solid transparent
        border-bottom 10px solid #fff
        transform rotate(-45deg)
      &::after
        content ''
        position absolute
        box-sizing content-box
        width 9px
        height 9px
        top 18px
        right -5px
        border-top 1px solid #ddd
        border-right 1px solid #ddd
        transform rotate(45deg)
      .qq-item
        display block
        padding-left 55px
        background-image url('../../../assets/pc/images/reference/qq.jpg')
        background-repeat no-repeat
        background-position 0 0
        span
          display block
      &.main-phone
        width 200px
        .phone
          padding-left 55px
          background-image url('../../../assets/pc/images/reference/phone.jpg')
          background-repeat no-repeat
          background-position 0 0
          .red-font
            color #f00
            font-size 18px
      &.wechat
        padding 20px
        .img
          width 130px
          height 130px
        p
          font-size 16px
          text-align center
          margin-top 10px
</style>
